import { APP_MARKET, AppMarket } from '@utils/marketHost'
import { network } from '@utils'
import { handleReturn } from './root'
import { ICurrentUser } from './currentUser'

export interface ILegalTerm {
  kind: string
  name: string
  url: string
}

export interface ILegalTermsPackage {
  history_id: number
  market: string
  terms: ILegalTerm[]
}

export const fetchLegalTerms = async (
  market: string,
  language?: string
): Promise<ILegalTermsPackage> => {
  const { data, status } = await network.httpClient.request({
    url: `/v1/terms/${market}/`,
    method: 'GET',
    params: language ? { language } : undefined,
    validateStatus: () => true
  })
  return handleReturn({ data, status })
}

export const hasAcceptedAppMarketTos = (user?: ICurrentUser): boolean | undefined => {
  if (!user) {
    return undefined
  }

  switch (APP_MARKET) {
    case AppMarket.FI:
      return user.tos_accepted_by_market?.[AppMarket.FI] ?? user.tos_accepted
    case AppMarket.DE:
      return user.tos_accepted_by_market?.[AppMarket.DE] ?? false
    default: {
      const exhaustive: never = APP_MARKET
      return exhaustive
    }
  }
}
